import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from '../../../environments/environment';
import { MainLayoutComponent } from './main-layout.component';
const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'profile',
        loadChildren: () =>
          import('../../user-profile/user-profile.module').then(
            (m) => m.UserProfileModule
          ),
        data: { title: 'My Profile', breadCrumb: 'Home,My Profile' },
      },
      {
        path: 'collections',
        loadChildren: () =>
          import('../../collections/collections.module').then(
            (m) => m.CollectionsModule
          ),
        data: { title: 'Customer - Home', breadCrumb: ['Home', 'Collections'] },
      },
      {
        path: 'featured-products',
        loadChildren: () =>
          import('../../featured-products/featured-products.module').then(
            (m) => m.FeaturedProductsModule
          ),
        data: {
          title: 'Featured Products',
          breadCrumb: ['Home', 'Featured Products'],
        },
      },
      {
        path: 'manage-seasons',
        loadChildren: () =>
          import('../../seasons/seasons.module').then((m) => m.SeasonsModule),
        data: {
          title: 'Manage Seasons',
          breadCrumb: ['Home', 'Manage Seasons'],
        },
      },
      {
        path: 'web-service',
        loadChildren: () =>
          import('../../web-services/web-services.module').then(
            (m) => m.WebServicesModule
          ),
        data: {
          title: 'Manage Web Service',
          breadCrumb: ['Home', 'Manage Web Service'],
        },
      },
      {
        path: 'destinations',
        loadChildren: () =>
          import('../../destinations/destinations.module').then(
            (m) => m.DestinationsModule
          ),
        data: { title: 'Destinations', breadCrumb: ['Home', 'Destinations'] },
      },
      {
        path: 'news',
        loadChildren: () =>
          import('../../news/news.module').then((m) => m.NewsModule),
        data: { title: 'News', breadCrumb: ['Home', 'News'] },
      },
      {
        path: 'static-content',
        loadChildren: () =>
          import('../../static-content/static-content.module').then(
            (m) => m.StaticContentModule
          ),
        data: {
          title: 'Static Content',
          breadCrumb: ['Home', 'Static Content'],
        },
      },
      {
        path: 'image-cover',
        loadChildren: () =>
          import('../../cover-images/cover-images.module').then(
            (m) => m.CoverImagesModule
          ),
        data: {
          title: 'Manage Image Coverflow',
          breadCrumb: ['Home', 'Manage Image Coverflow'],
        },
      },
      {
        path: 'documents',
        loadChildren: () =>
          import('../../documents/documents.module').then(
            (m) => m.DocumentsModule
          ),
        data: {
          title: 'Manage Documents',
          breadCrumb: ['Home', 'Manage Documents'],
        },
      },
      {
        path: 'messages',
        loadChildren: () =>
          import('../../messages/messages.module').then(
            (m) => m.MessagesModule
          ),
        data: {
          title: 'Manage messages',
          breadCrumb: ['Home', 'Manage messages'],
        },
      },
      {
        path: 'manage-link',
        loadChildren: () =>
          import('../../external-links/external-links.module').then(
            (m) => m.ExternalLinksModule
          ),
        data: {
          title: 'Manage External Links',
          breadCrumb: ['Home', 'Manage External Links'],
        },
      },
      {
        path: 'groups',
        loadChildren: () =>
          import('../../groups/groups.module').then((m) => m.GroupsModule),
        data: { title: 'Manage groups', breadCrumb: ['Home', 'Manage groups'] },
      },
      {
        path: 'brand',
        loadChildren: () =>
          import('../../brands/brands.module').then((m) => m.BrandsModule),
        data: { title: 'Manage Brands', breadCrumb: ['Home', 'Manage Brands'] },
      },
      {
        path: 'season-workbench',
        loadChildren: () =>
          import('../../season-workbench/season-workbench.module').then(
            (m) => m.SeasonWorkbenchModule
          ),
        data: {
          title: 'Manage Season Workbench',
          breadCrumb: ['Home', 'Manage Season Workbench'],
        },
      },
      {
        path: 'menu/drag',
        loadChildren: () =>
          import('../../menu-drag/menu-drag.module').then(
            (m) => m.MenuDragModule
          ),
        data: { title: 'menu-drag', breadCrumb: ['Home', 'menu-drag'] },
      },
      {
        path: 'user',
        loadChildren: () =>
          import('../../users/users.module').then((m) => m.UsersModule),
        data: { title: 'Manage Users', breadCrumb: ['Home', 'Manage Users'] },
      },
      {
        path: 'expired-carts',
        loadChildren: () =>
          import('../../expired-carts/expired-carts.module').then(
            (m) => m.ExpiredCartsModule
          ),
        data: { title: 'Expired Carts', breadCrumb: ['Home', 'Expired Carts'] },
      },
      {
        path: 'role',
        loadChildren: () =>
          import('../../roles/roles.module').then((m) => m.RolesModule),
        data: { title: 'Roles', breadCrumb: ['Home', 'Roles'] },
      },
      {
        path: 'menu',
        loadChildren: () =>
          import('../../manage-menu/manage-menu.module').then(
            (m) => m.ManageMenuModule
          ),
        data: { title: 'Manage Menu', breadCrumb: ['Home', 'Manage Menu'] },
      },
      {
        path: 'global-linesheet',
        loadChildren: () =>
          import('../../global-linesheets/global-linesheets.module').then(
            (m) => m.GlobalLinesheetsModule
          ),
        data: {
          title: 'Manage Globalsheet',
          breadCrumb: ['Home', 'Manage Globalsheet'],
        },
      },
      {
        path: 'proposals/reports',
        loadChildren: () =>
          import('../../reports/reports.module').then((m) => m.ReportsModule),
        data: {
          title: 'Proposals Reports',
          breadCrumb: ['Home', 'Proposals Reports'],
        },
      },
      {
        path: 'proposals',
        loadChildren: () =>
          import('socx-proposals').then((m) => {
            /**
             * FIXME: I don't think this is the correct way to pass data to the
             * lazy loaded module. Need more exploration!!
             */
            const apiUrl = environment.SERVER_API_URL + '/api';
            m.ProposalsModule.forChild({ apiUrl, hostApp: 'socx-admin', driveCommerceApi: environment.DRIVE_COMMERCE_API_KEY });
            return m.ProposalsModule;
          }),
        data: { title: 'Proposals', breadCrumb: ['Home', 'Proposals'] },
      },
      {
        path: 'member-users',
        loadChildren: () =>
          import('socx-member-users').then((m) => {
            const apiUrl = environment.SERVER_API_URL + '/api';
            m.MemberUsersModule.forChild({ apiUrl, hostApp: 'socx-admin' });
            return m.MemberUsersModule;
          }),
        data: { title: 'Member Users', breadCrumb: ['Home', 'Member Users'] },
      },
      {
        path: 'proposal-images',
        loadChildren: () =>
          import('socx-proposal-image-uploads').then((m) => {
            const apiUrl = environment.SERVER_API_URL + '/api';
            m.ImageUploadModule.forChild({
              apiUrl,
              hostApp: 'socx-admin',
            });
            return m.ImageUploadModule;
          }),
        data: {
          title: 'Proposal Images',
          breadCrumb: ['Home', 'Proposal Images'],
        },
      },
      {
        path: 'order-history',
        loadChildren: () =>
          import('socx-order-history').then((m) => {
            const apiUrl = environment.SERVER_API_URL + '/api';
            m.SocxOrderHistoryModule.forChild({
              apiUrl,
              hostApp: 'socx-admin',
            });
            return m.SocxOrderHistoryModule;
          }),
        data: { title: 'Order History', breadCrumb: ['Home', 'Order History'] },
      },
      {
        path: 'leadtime',
        loadChildren: () =>
          import('../../lead-time-config/lead-time-config.module').then(
            (m) => m.LeadTimeConfigModule
          ),
        data: {
          title: 'Lead Time',
          breadCrumb: ['Home', 'Lead Time'],
        },
      },
      {
        path: 'global-configs',
        loadChildren: () =>
          import('../../global-configuration/global-configuration.module').then(
            (m) => m.GlobalConfigurationModule
          ),
        data: {
          title: 'Global Configuration',
          breadCrumb: ['Home', 'Global Configuration'],
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainLayoutRoutingModule {}
